<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-undef -->
<script setup>
import Footer from "@/components/Footer";
import NavbarSecond from '@/components/NavbarSecond.vue';
import NavbarSecondDark from '@/components/NavbarSecondDark.vue';
import { reactive } from "@vue/reactivity";
import { onBeforeMount, onMounted, ref } from "@vue/runtime-core";
import axios from "axios";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Ic360Degre from "@/assets/2024/icons/360-degre.png";
import ImgFindYourHotel from "@/assets/samples/find-your-hotel.png";
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import Modal3d from "@/components/Modal3d.vue";
import { facilities } from "@/utils/hotelFacilities";

let navbarDark = ref(false);
let store = useStore();
let route = useRoute();
let hotel = reactive({
  data: null,
  loading: false,
  photo_active: null,
});

onBeforeMount(() => {
});
onMounted(() => {
  hotel.loading = true;
  axios
    .get(`${store.state.urlNewInventoryFront}phri-venue/${route.params.id}`)
    .then((res) => {
      hotel.data = res.data.data;
      if (res.data.data.photos.length) {
        if (res.data.data.photos.filter((photo) => photo.is_primary === 1).length) {
          hotel.photo_active = res.data.data.photos.filter((photo) => photo.is_primary === 1)[0]?.path_formated;
        } else {
          hotel.photo_active = res.data.data.photos?.path_formated;
        }
      }
      hotel.loading = false;
    })
    .catch((err) => {
      console.log(err);
      hotel.loading = false;
    });
});

// onscroll
document.addEventListener("scroll", function () {
  if (window.pageYOffset > 590) {
    navbarDark.value = true;
  } else {
    navbarDark.value = false;
  }
});

let urlModal3d = ref("");
const showModal = (url) => {
  urlModal3d.value = url;
  const modalElement = document.getElementById('virtual3DModal');
  const modal = new bootstrap.Modal(modalElement);
  modal.show();
};
</script>

<template>
  <Modal3d :url="urlModal3d" />
  <div class="bg-white">
    <NavbarSecond v-if="!navbarDark" />
    <NavbarSecondDark v-else />
    <section class="p-0" style="overflow: hidden">
      <div class="row text-center">
        <div class="col-lg-12">
          <div class="card bg-primary-mice text-white shadow border-0 card-banner" style="">
            <div class="bg-flower"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="container container-content" style="">
      <div class="row text-center">
        <div class="col-lg-12">
          <div class="card border-0 bg-dark text-white rounded-custome shadow position-relative"
            style="border-radius: 30px; z-index: 3;">
            <div class="position-absolute top-50 translate-middle-y px-lg-5" style="
                width: 100%;
                height: 50%;
                background-color: rgba(0, 0, 0, 0.7);
                filter: blur(70px);
                left: 0%;
                border-radius: 30px;
              "></div>
            <img :src="ImgFindYourHotel" class="card-img d-none" style="border-radius: 30px;" alt="Banner" />
            <img :src="hotel.photo_active || ImgFindYourHotel" class="card-img" style="border-radius: 30px;"
              alt="Banner">
            <div class="card-img-overlay">
              <div v-if="hotel.data?.image_360"
                class="position-absolute top-50 start-50 translate-middle d-none d-lg-block text-center">
                <h1 class="text-white fw-bold mb-3">Explore your imagination <br>
                  with our 360 view</h1>
                <button type="button" style="border-radius: 20px;" class="btn btn-warning-mice text-black"
                  @click="showModal(hotel.data?.image_360)">
                  GET YOUR
                  EXPERIENCE
                </button>
              </div>
              <div v-if="hotel.data?.image_360" class="position-absolute d-block d-lg-none text-center h-100 w-100"
                style="top:0;left:0;">
                <div class="d-flex h-100 w-100 flex-column align-items-center justify-content-center">
                  <h6 class="text-white fw-bold mb-3">Explore your imagination <br>
                    with our 360 view</h6>
                  <button type="button" style="border-radius: 20px;" class="btn btn-warning-mice btn-sm text-black"
                    @click="showModal(hotel.data?.image_360)">
                    GET YOUR
                    EXPERIENCE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container-xl pt-5">
      <div class="row">
        <div class="col-lg-6 mb-2 mb-lg-1">
          <div class="d-flex">
            <h1 class="text-primary-mice fw-bold pe-3">{{ hotel.data?.name }}</h1>
            <div class="">
              <img v-if="hotel.data?.image_360" :src="Ic360Degre" alt="" style="" class="img-360">
            </div>
          </div>
          <p class="text-primary-mice mt-2 text-uppercase">{{ hotel.data?.area }} Convention Center</p>
        </div>
        <div class="col-lg-6 text-primary-mice text-end d-none d-lg-inline">
          <div class="d-flex fw-bold gap-3 justify-content-end align-items-center">
            <div v-if="hotel.data?.phone" class="d-flex align-items-center">
              <i class="fas fa-phone me-2"></i> +{{ hotel.data?.phone }}
            </div>
            <div v-if="hotel.data?.email" class="d-flex align-items-center">
              <i class="fas fa-envelope me-2"></i> {{ hotel.data?.email }}
            </div>
            <div v-if="hotel.data?.instagram" class="d-flex align-items-center">
              <i class="fab fa-instagram me-2"></i> {{ hotel.data?.instagram }}
            </div>
          </div>
          <div class="text-end mt-3">
            <span v-if="hotel.data?.address">
              {{ hotel.data?.address }},
            </span>
            <span v-if="hotel.data?.village_name">
              {{ hotel.data?.village_name }},
            </span>
            <span v-if="hotel.data?.subdistrict_name">
              {{ hotel.data?.subdistrict_name }},
            </span>
            <span v-if="hotel.data?.city_name">
              {{ hotel.data?.city_name }},
            </span>
            <span v-if="hotel.data?.province_name">
              {{ hotel.data?.province_name }}
            </span>
            <span v-if="hotel.data?.postal_code" class="ms-2">
              {{ hotel.data?.postal_code }}
            </span>
          </div>
        </div>
      </div>
      <div class="row pt-lg-5">
        <div class="col-12">
          <div class="p-0 ql-editor" v-html="hotel.data?.description"></div>
        </div>
      </div>
      <div class="row pt-5" v-if="hotel.data?.photos?.length">
        <div class="col-12">
          <Carousel class="" :wrap-around="true">
            <Slide v-for="(data, i) in hotel.data?.photos" :key="i">
              <div class="carousel__item">
                <img :src="data.path_formated" :alt="hotel.data?.name" style="width: 100%" />
              </div>
            </Slide>
            <template #addons>
              <Navigation />
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>
      <div class="row pt-5 text-primary-mice">
        <h2 class="mb-3">Hall Type</h2>
        <div class="table-responsive">
          <table class="table table-bordered ">
            <thead>
              <tr>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Room Name</th>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Size</th>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Dimension</th>
                <th colspan="5" class="fw-bold text-primary-mice text-center">Capacity</th>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Image</th>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Floorplan</th>
                <th rowspan="2" class="fw-bold text-primary-mice text-center">Virtual</th>
              </tr>
              <tr>
                <th class="fw-bold text-primary-mice text-center">Round</th>
                <th class="fw-bold text-primary-mice text-center">Theater</th>
                <th class="fw-bold text-primary-mice text-center">U Shape</th>
                <th class="fw-bold text-primary-mice text-center">Class</th>
                <th class="fw-bold text-primary-mice text-center">Board</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(room, roomIdx) in hotel.data?.hall_rooms" :key="roomIdx">
                <td class="text-primary-mice text-center">{{ room.room_name }}</td>
                <td class="text-primary-mice text-center">{{ room.size }}m<sup>2</sup> </td>
                <td class="text-primary-mice text-center">{{ room.dimension }}m<sup>2</sup> </td>
                <td class="text-primary-mice text-center">{{ room.round }} Person</td>
                <td class="text-primary-mice text-center">{{ room.theater }} Person</td>
                <td class="text-primary-mice text-center">{{ room.u_shape }} Person</td>
                <td class="text-primary-mice text-center">{{ room.classroom }} Person</td>
                <td class="text-primary-mice text-center">{{ room.boardroom }} Person</td>
                <td class="text-primary-mice text-center">
                  <img v-if="room.photos?.filter(photo => photo.is_primary === 1)?.length"
                    :src="room.photos?.filter(photo => photo.is_primary === 1)[0]?.path_formated" alt=""
                    style="width: 7rem;">
                </td>
                <td class="text-primary-mice text-center">{{ room.floorplan }}</td>
                <td class="text-primary-mice text-center">
                  <button v-if="room.image_360" class="btn btn-primary-mice rounded-custom"
                    @click="showModal(room.image_360)">Go
                    360<sup>0</sup></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row pt-5 text-primary-mice">
        <div class="col-lg-6">
          <h2 class="mb-3">Facilities</h2>
          <div class="row">
            <div class="col-lg-6"
              v-for="facility in facilities().filter(facility => hotel.data?.facilities?.includes(facility.slug))"
              :key="facility.slug">
              <div class="form-check py-1">
                <label class="form-check-label" :for="facility.slug">
                  <img :src="facility.icon" alt="" style="width: 1rem; height: 1rem; margin-right: 0.5rem;">
                  {{
                    facility.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row pt-3 text-primary-mice">
        <div class="col-lg-6">
          <h2 class="mb-3">Nearest Place</h2>
          <div class="row">
            <div v-for="(place, placeIdx) in hotel.data?.nearest_places" :key="placeIdx" class="py-1 col-lg-6">
              <div class="d-flex gap-3">
                <h5>{{ place.name }}</h5>
                <div>
                  <sup class="badge bg-secondary" style="font-size: 0.6rem; margin-top: -1rem">{{ place.distance
                    }}</sup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row pt-3 text-primary-mice">
        <div class="col-lg-12">
          <h2 class="mb-3">Location</h2>
          <div class="">
            <GMapMap style="width: 100%; height: 500px; border-radius: 2rem" :center="{
              lat: parseFloat(hotel.data?.latitude),
              lng: parseFloat(hotel.data?.longitude),
            }" :zoom="15" v-if="hotel.data?.latitude && hotel.data?.longitude">
              <GMapMarker :position="{
                lat: parseFloat(hotel.data?.latitude),
                lng: parseFloat(hotel.data?.longitude),
              }" :clickable="false" :draggable="false" />
            </GMapMap>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="mt-lg-4 mt-3">
            Alamat:
            <span v-if="hotel.data?.address">
              {{ hotel.data?.address }},
            </span>
            <span v-if="hotel.data?.village_name">
              {{ hotel.data?.village_name }},
            </span>
            <span v-if="hotel.data?.subdistrict_name">
              {{ hotel.data?.subdistrict_name }},
            </span>
            <span v-if="hotel.data?.city_name">
              {{ hotel.data?.city_name }},
            </span>
            <span v-if="hotel.data?.province_name">
              {{ hotel.data?.province_name }}
            </span>
            <span v-if="hotel.data?.postal_code" class="ms-2">
              {{ hotel.data?.postal_code }}
            </span>
          </div>
        </div>
      </div>
      <hr class="d-lg-none" />
      <div class="row pt-3 text-primary-mice d-lg-none">
        <div class="col-lg-6">
          <h2 class="mb-3">Contact</h2>
          <div class="d-flex fw-bold gap-3 justify-content-start align-items-center flex-wrap">
            <div v-if="hotel.data?.phone" class="d-flex align-items-center w-100">
              <i class="fas fa-phone me-2"></i> +{{ hotel.data?.phone }}
            </div>
            <div v-if="hotel.data?.email" class="d-flex align-items-center w-100">
              <i class="fas fa-envelope me-2"></i> {{ hotel.data?.email }}
            </div>
            <div v-if="hotel.data?.instagram" class="d-flex align-items-center">
              <i class="fab fa-instagram me-2"></i> {{ hotel.data?.instagram }}
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="py-4">&nbsp;</section>
    <Footer />
  </div>
</template>

<style scoped>
.bg-flower {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
  width: 30%;
  height: 90%;
  z-index: 2;
  background-image: url('../../../assets/2024/images/flower-hotel-detail.png');
  background-size: cover;
  background-repeat: no-repeat;
}

.card-banner {
  min-height: 30vh;
}

.container-content {
  margin-top: -15vh;
}

.img-other-logo {
  max-height: 2.5rem;
}

.img-360 {
  max-width: 5rem;
}

.fa-star {
  font-size: 1rem;
}

@media (min-width: 992px) {
  .fa-star {
    font-size: 1.3rem;
  }

  .img-other-logo {
    max-height: 3.5rem;
  }

  .img-360 {
    max-width: 7rem;
  }

  .card-banner {
    min-height: 80vh;
  }

  .container-content {
    margin-top: -60vh;
  }

  .img-wrap {
    clear: right;
    float: left;
    width: 30em;
    margin-right: 2em;
  }
}
</style>